// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3z5ed","title":"BackImages_title__uiKcA","images":"BackImages_images__2xR_H"};